// Keep these rules and fixtures aligned with revenova/business_hours.go.
// Bare hours ("7-2") are ambiguous. Never infer AM/PM or convert timezones.
export function normalizeBusinessHours(value: string): string | null {
  const raw = value.trim();
  if (!raw) return '';
  const parts = raw.split(/\s*(?:-|–|—|\bto\b)\s*/i);
  if (parts.length !== 2) return null;
  const open = normalizeHoursTime(parts[0]);
  const close = normalizeHoursTime(parts[1]);
  return open && close ? `${open}-${close}` : null;
}

export function normalizeHoursTime(value: string): string | null {
  const raw = value.trim();

  // 6AM, 6:30 PM, or 6:30:00 PM. Bare hours require an explicit AM/PM.
  const twelveHour = raw.match(/^(\d{1,2})(?::(\d{2})(?::00)?)?\s*(am|pm)$/i);
  if (twelveHour) {
    const [, hourText, minuteText = '00', meridiem] = twelveHour;
    const hour = Number(hourText);
    if (hour < 1 || hour > 12) return null;

    const afternoonOffset = meridiem.toLowerCase() === 'pm' ? 12 : 0;
    return formatHoursTime((hour % 12) + afternoonOffset, Number(minuteText));
  }

  // 06:30, 06:30:00, or 0630. Both patterns capture hours and minutes.
  const twentyFourHour =
    raw.match(/^(\d{1,2}):(\d{2})(?::00)?$/) ?? raw.match(/^(\d{2})(\d{2})$/);
  if (!twentyFourHour) return null;

  const [, hourText, minuteText] = twentyFourHour;
  return formatHoursTime(Number(hourText), Number(minuteText));
}

function formatHoursTime(hour: number, minute: number): string | null {
  if (hour > 23 || minute > 59) return null;
  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
}
